import { formatMoney } from '../lib/money';
import type { MoneyOptions } from '../lib/money';

export interface MoneyProps extends MoneyOptions {
  amount: number;
  currency: string;
  size?: number | string;
  /** Colours the number: green when owed, red when owing, muted at zero. */
  tone?: 'auto' | 'plain' | 'muted';
  weight?: number;
}

/**
 * Every amount on screen goes through here, so that tabular figures and the
 * sign convention are decided once. `.num` is the Manrope + tabular-nums
 * utility in index.css — without it, columns of money jitter as the digits
 * change width.
 */
export function Money({
  amount,
  currency,
  size,
  tone = 'plain',
  weight = 400,
  ...options
}: MoneyProps) {
  const color =
    tone === 'muted'
      ? 'var(--text-muted)'
      : tone === 'auto'
        ? amount < -0.005
          ? 'var(--error)'
          : amount > 0.005
            ? 'var(--accent)'
            : 'var(--text-muted)'
        : undefined;

  return (
    <span className="num" style={{ fontSize: size, color, fontWeight: weight, letterSpacing: '-0.01em' }}>
      {formatMoney(amount, currency, options)}
    </span>
  );
}
